// extracted by mini-css-extract-plugin
export var body = "_25-8";
export var button = "_25-0";
export var closeButton = "_25-5";
export var content = "_25-3";
export var empty = "_25-f";
export var grid = "_25-c";
export var header = "_25-4";
export var icon = "_25-1";
export var option = "_25-d";
export var optionSelected = "_25-e";
export var overlay = "_25-2";
export var searchIcon = "_25-a";
export var searchInput = "_25-b";
export var searchWrapper = "_25-9";
export var title = "_25-6";
export var visuallyHidden = "_25-7";